// src/html.tsx
import * as React from "react";
import { jsx } from "react/jsx-runtime";
var Html = React.forwardRef(
  ({ children, lang = "en", ...props }, forwardedRef) => /* @__PURE__ */ jsx("html", { ref: forwardedRef, lang, ...props, children })
);
Html.displayName = "Html";
export {
  Html
};
